<script setup lang="ts">
defineProps<{
  label: string
}>()
</script>

<template>
  <div class="flex items-start justify-between gap-4 text-sm">
    <span class="shrink-0 text-[#6b7280]">{{ label }}</span>
    <div class="text-end font-medium text-[#1b325a]">
      <slot />
    </div>
  </div>
</template>
